import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { Button } from "@similarweb/ui-components";
import styled from "styled-components";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const SectionContainer = styled.div`
    flex-direction: column;
    justify-content: center;
    width: 100%;
`;

export const RecentsContainer = styled(FlexColumn)`
    justify-content: flex-start;
    width: 100%;
    border-radius: 6px;
    background-color: rgb(236, 241, 255);
`;

export const CardsList = styled.div<{
    open: boolean;
    cardHeight: number;
    maxDisplay: number;
    compactDisplay: number;
    spaceBetween: number;
}>`
    padding: 8px;
    max-height: ${(props) => {
        const currentDisplay = props.open ? props.maxDisplay : props.compactDisplay;
        const totalCardsHeight = currentDisplay * props.cardHeight;
        const totalSpaceHeight = (currentDisplay - 1) * props.spaceBetween;
        return totalCardsHeight + totalSpaceHeight;
    }}px;
    overflow: hidden;
    transition: max-height 0.3s ease-in-out;

    & > * {
        margin-bottom: ${(props) => props.spaceBetween}px;
    }
`;

export const SeeMoreButton = styled(Button)`
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin: 0 auto 8px;
    padding: 8px 16px;
    background: none;
    outline: none;
    border: none;
    border-radius: 18px;
    ${setFontVariant("button", colorsPalettes.blue[400])};
    transition: all ease-in 0.3s;

    &:hover {
        background-color: ${colorsPalettes.carbon[200]}33;
    }

    &:active {
        background-color: ${colorsPalettes.carbon[100]}33;
    }

    &:hover:not(:active) {
        color: ${colorsPalettes.blue[500]};
    }

    & > span {
        font-family: "DM Sans", sans-serif;
    }
`;

export const ChevIcon = styled(SWReactIcons)<{
    directionDown: boolean;
}>`
    margin: 1px 5px 0 0;
    transform: rotate(${(props) => (props.directionDown ? 0 : 180)}deg);
    transition: 0.2s;

    & svg > path {
        fill: ${colorsPalettes.blue[400]} !important;
    }
`;
